import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { WEBSITE_LOCAL_LINKS } from './offerData';

const OfferLocalLinks: React.FC = () => (
  <section className="py-10 bg-[#36393F]" aria-label="Création de site internet près de chez vous">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <p className="text-gray-300 text-sm mb-4">Vous cherchez un prestataire près de chez vous ?</p>
      <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {WEBSITE_LOCAL_LINKS.map(({ label, href }) => (
          <li key={href}>
            <Link to={href} className="inline-flex items-center gap-1.5 text-sm text-[#9BA8FF] hover:text-white transition-colors">
              <ArrowRight className="h-4 w-4" aria-hidden="true" /> {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default OfferLocalLinks;
